<template>
  <full-container :padding="0">
    <div slot="header" class="toolbar">
      <el-input v-model="queryParams.keyWord" clearable style="width: 240px">
        <el-button slot="append" class="el-icon-search" @click="onSearch()" />
      </el-input>
    </div>
    <el-table ref="tb" :data="datalist.Items" height="100%" @selection-change="handleSelectionChange">
      <el-table-column prop="Name" label="姓名" min-width="120" />
      <el-table-column prop="Account" label="登录名" min-width="120" />
      <el-table-column prop="Phone" label="手机号" min-width="120" />
      <el-table-column type="selection" width="55" align="center" />
    </el-table>
    <div class="toolbar" slot="footer">
      <el-pagination layout="prev, next" :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onSearch" />
      <el-button type="primary" size="samll" @click="onSelect">确定</el-button>
    </div>
  </full-container>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      queryParams: { index: 1, size: 20 },
      datalist: {},
      selection: []
    }
  },
  created () {
    this.onSearch()
  },
  props: {
    multiple: { type: Boolean, default: false },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.organize.staff.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    // 多选框选中数据
    handleSelectionChange (e) {
      if (this.multiple) {
        this.selection = e
      }
      else {
        this.selection = e[0]
        if (e.length > 1) {
          this.$refs.tb.clearSelection()
          this.$refs.tb.toggleRowSelection(e.pop())
        }
      }
    },
    onSelect () {
      this.callback(this.selection)
      this.$layer.close(this.layerid)
    }
  }
}
</script>